import { render, staticRenderFns } from "./Abandon.vue?vue&type=template&id=b622f1c4&"
import script from "./Abandon.vue?vue&type=script&lang=js&"
export * from "./Abandon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports